import {
  arrayOf,
  shape,
  string,
  number,
  instanceOf,
  oneOfType,
} from 'prop-types';

export const entityPropType = shape({
  entity: shape({
    id: string.isRequired,
    type: string.isRequired,
  }),
  data: arrayOf(
    shape({
      periodKey: number.isRequired,
      value: number,
      date: oneOfType([instanceOf(Date), string]),
    })
  ).isRequired,
  breakdown: oneOfType([string, number]),
  countryId: string,
});

const entitiesPropType = arrayOf(entityPropType.isRequired);

export default entitiesPropType;
